import { render } from "./pop_environment.vue?vue&type=template&id=faf115d6&scoped=true"
import script from "./pop_environment.vue?vue&type=script&lang=js"
export * from "./pop_environment.vue?vue&type=script&lang=js"

import "./pop_environment.vue?vue&type=style&index=0&id=faf115d6&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/smt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faf115d6"]])

export default __exports__